import { useTranslations } from 'next-intl';

import pom from '@/utils/pom';
import { applyDataTestId } from '@/utils/testUtils';
import CheckIcon from '@/components/_icons/checkIcon';
import { cloverColorTheme } from '@/utils/cloverColorTheme';

interface ReorderedItemAddedToCartBannerProps {
  readonly itemName: string;
}

const ReorderedItemAddedToCartBanner = ({ itemName }: ReorderedItemAddedToCartBannerProps) => {
  const t = useTranslations('ReorderedItemAddedToCartBanner');

  return (
    <div
      data-testid={applyDataTestId(pom.orders.reorderedItemAddedToCartBanner)}
      className="bg-[#F2FCEE] rounded-lg border border-[#228800] gap-4 flex p-3 w-100"
    >
      <CheckIcon color={cloverColorTheme.Main.primaryColor} />
      <p>{t('message', { itemName })}</p>
    </div>
  );
};

export default ReorderedItemAddedToCartBanner;
